import React from "react";
import { NavLink } from "react-router-dom";
import { logOutAsyncThunk } from "../../store/slice/userSlice";
import { useDispatch } from "react-redux";

const Navigation = () => {
  const setClassName = ({ isActive }) => (isActive ? "navigation__item active" : "navigation__item");
  const dispatch = useDispatch();
  return (
    <div className="navigation">
      <NavLink to="/" end className={setClassName}>
        <span>Home Page</span>
      </NavLink>
      <NavLink to="/orders" end className={setClassName}>
        <span>My bookings</span>
      </NavLink>
      <NavLink to="/profile" end className={setClassName}>
        <span>Profile Info</span>
      </NavLink>
      <button onClick={() => dispatch(logOutAsyncThunk())} className="navigation__item">
        Exit
      </button>
    </div>
  );
};

export default Navigation;
